import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

type SourceStringEnum = "wise" | "spirometer";

export default class VemsDeclaredJournalEvent extends JournalEvent {
  static override type = "vems-declared-journal-event";

  @attr("number") declare value1: number;

  @attr("number") declare value2: number;

  @attr("number") declare value3: number;

  @attr("string") declare source: SourceStringEnum;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.vems-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      value1: validateNumber({
        allowBlank: true,
        gt: 0,
        lte: 5,
        description: intl.t("validations.vems-declared-journal-event.value1")
      }),
      value2: validateNumber({
        allowBlank: true,
        gt: 0,
        lte: 5,
        description: intl.t("validations.vems-declared-journal-event.value2")
      }),
      value3: validateNumber({
        allowBlank: true,
        gt: 0,
        lte: 5,
        description: intl.t("validations.vems-declared-journal-event.value3")
      }),
      source: validateInclusion({
        list: ["wise", "spirometer"],
        allowBlank: true,
        description: intl.t("validations.vems-declared-journal-event.source")
      })
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "vemsDeclaredJournalEvents"
  })
  declare patient: Patient;

  get highestValue() {
    if (!this.value1 && !this.value2 && !this.value3) {
      return;
    }

    return Math.max(this.value1 || 0, this.value2 || 0, this.value3 || 0);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "vems-declared-journal-event": VemsDeclaredJournalEvent;
  }
}
